// @ts-nocheck
/**
 * Use this function to simulate an async request.
 * Example: await sleep(500);
 * @param ms The number of milliseconds to wait
 * @returns void
 */
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
